import { Box } from "@mui/material";
import React from "react";
import Nav from "../../compontents/Nav";
import { LuCpu } from "react-icons/lu";

const AlgoList = ({ isSidebarOpen = true }) => {
  return (
    <>
      <div className={`${isSidebarOpen ? "col-lg-9" : "col-lg-12"} pt-4 pb-2 pb-sm-4`}>
        <div className="container">
          <h2 className="d-flex align-items-center">
            <LuCpu className="text-primary me-2" size={30} />
            Manage Algo
          </h2>
          <div className="mt-4">
            <div className="card card--primary shadow-primary">
              <div className="card-body">
                <div className="border-danger-100 pt-3">
                  <p className="text-success mb-3">
                    Today is the end of the Republic. The end of a regime that
                    acquiesces to disorder. At this very moment, in a system
                    far from here, the New Republic lies to the galaxy while
                    secretly supporting the treachery of the loathsome
                    Resistance. This fierce machine which you have built, upon
                    which we stand, will bring an end to the Senate, to their
                    cherished fleet.
                  </p>
                  <p className="text-danger fw-bold">
                    All remaining systems will bow to the First Order and
                    remember this as the last day of the Republic!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AlgoList;
